import { type ReactNode } from 'react'

import { cn } from '@/utils/commonUtil'

import styles from './StatCommonFigure.module.scss'

type Props = {
  children: ReactNode
  colorScheme?: 'neutral' | 'positive' | 'negative' | 'highlight'
  icon?: ReactNode
  prefix?: ReactNode
  size?: 'sm' | 'lg'
  suffix?: ReactNode
  value?: string
}

export const StatCommonFigure = ({ children, colorScheme = 'neutral', icon, prefix, size, suffix, value }: Props) => (
  <span className={cn(styles.container, { colorScheme, size, styles })}>
    {icon && <span className={styles.icon}>{icon}</span>}
    <data className={styles.figure} value={value}>
      {prefix && <span className={styles.affix}>{prefix}</span>}
      <span className={styles.value}>{children}</span>
      {suffix && <span className={styles.affix}>{suffix}</span>}
    </data>
  </span>
)
